<section class="affiliate-section" tabindex="-1">
    <div class="background-video-container">
      <video #backgroundVideo class="background-video" aria-label="Business Meeting" playsinline preload="auto" muted loop autoplay>
        <source src="https://video.wixstatic.com/video/11062b_50f6f6470c9642078f20bc034734c14b/1080p/mp4/file.mp4" type="video/mp4">
      </video>
      <img class="video-poster" src="https://static.wixstatic.com/media/11062b_50f6f6470c9642078f20bc034734c14bf000.jpg/v1/fill/w_1513,h_529,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/11062b_50f6f6470c9642078f20bc034734c14bf000.jpg" alt="">
    </div>
    
    <div class="content-container">
      <div class="text-box">
        <h1 class="heading">Adopt our affiliate platform to streamline campaigns, leverage real-time analytics, and maximize your earnings.</h1>
      </div>
      
      <div class="button-container">
        <a href="https://ecomdev.calsoftgroup.com/register/affiliate" target="_blank" rel="noopener noreferrer" class="join-button">
          JOIN US
          <span class="button-icon">
            <svg viewBox="0 0 200 200" height="200" width="200" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 29.5c-38.874 0-70.5 31.626-70.5 70.5s31.626 70.5 70.5 70.5 70.5-31.626 70.5-70.5-31.626-70.5-70.5-70.5zm0 133c-34.463 0-62.5-28.037-62.5-62.5S65.537 37.5 100 37.5s62.5 28.037 62.5 62.5-28.037 62.5-62.5 62.5zm30.09-60.584c-.055.101-.099.205-.164.302a3.99 3.99 0 0 1-.501.613l-26.597 26.597c-.78.781-1.805 1.172-2.828 1.172s-2.048-.391-2.828-1.172a4 4 0 0 1 0-5.656L116.943 104H73.4a4 4 0 0 1 0-8h43.542l-19.77-19.771a4 4 0 1 1 5.656-5.656l26.597 26.597c.187.187.354.392.501.613.065.097.109.201.164.302.07.127.147.25.203.386.055.132.086.27.126.405.034.114.078.223.101.341.103.517.103 1.05 0 1.566-.023.118-.068.227-.101.341-.04.136-.071.273-.126.405-.055.136-.132.259-.203.387z"></path>
            </svg>
          </span>
        </a>
      </div>
    </div>
  </section>